import React from "react";
import { Pie } from "react-chartjs-2";

// Qualitative palette, cycled when there are more categories than colors.
const PALETTE = [
  "#5B93FF",
  "#FFD66B",
  "#05CD99",
  "#AE8FF7",
  "#FF8F6B",
  "#4FD1C5",
  "#F76FB2",
  "#9CA3AF",
  "#FBBF24",
  "#60A5FA",
  "#34D399",
  "#C084FC",
];

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    datalabels: { display: false },
    legend: {
      align: "center",
      position: "bottom",
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        font: "Nunito",
        padding: 12,
        color: "#030229",
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          const value = context.parsed || 0;
          const total = context.dataset.data.reduce((sum, v) => sum + (v || 0), 0);
          const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
          return ` ${context.label}: ${value.toLocaleString("fr-FR")} (${percentage}%)`;
        },
      },
    },
  },
};

const PieChart = ({ labels = [], values = [] }) => {
  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: labels.map((_, index) => PALETTE[index % PALETTE.length]),
        borderWidth: 0,
      },
    ],
  };

  return (
    <Pie
      options={options}
      data={data}
    />
  );
};

export default PieChart;
